import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import { GetAllocationDocument } from 'generated/resources/graphql'
import { isEmpty } from 'lodash'

import MoneyField from 'modules/core/components/MoneyField'
import TextField from 'modules/core/components/TextField'
import { useQuery } from 'modules/core/hooks/useQuery'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import { fromCents } from 'modules/core/lib/formatCurrencyUtils'
import i18n from 'modules/core/lib/i18n'

import Document from 'modules/documents/store/models/Document'
import {
  allocationStatusText,
  allocationTagColor,
  budgetStatusText,
  budgetTagColor,
} from 'modules/finance/lib/budgetTagInfo'

import Documents from '../../BasePendingApprovals/components/Documents'
import type { CollapseContentData } from '../types'
import Link from './Link'

interface Props {
  collapseContentData: CollapseContentData
}

const ExpenseRightBlock = ({ collapseContentData: { amount, ...collapseContentData } }: Props) => {
  const employeeId = Number(collapseContentData.owner?.id)

  const budgetMovement = collapseContentData?.bugdetMovement
  const budget = budgetMovement?.budget

  const { data: allocationData, loading: loadingAllocation } = useQuery(GetAllocationDocument, {
    variables: {
      employeeIds: [employeeId],
      budgetId: Number(budget?.id),
      periodStart: budget?.currentPeriodStart,
    },
    skip: !budget?.id,
  })
  const budgetAllocation = allocationData?.finance.budgetAllocationsConnection.nodes[0]

  const files = collapseContentData.expense?.files || []

  return (
    <Box width="full" gap="s24">
      {!loadingAllocation && budget && (
        <Box gap="s8">
          <Box flexDirection="row" gap="s4" alignItems="center">
            <Text weight="medium" size="200" color="grey1000">
              {i18n.t('budgets.forms.external_resource.budget_field.label')}
            </Text>
          </Box>
          <Box width="fit-content">
            {budgetAllocation?.status ? (
              <Tag type={allocationTagColor(budgetAllocation.status)}>
                {allocationStatusText(budgetAllocation.status)}
              </Tag>
            ) : (
              <Tag type={budgetTagColor(budget.currentStatus)}>
                {budgetStatusText(budget.currentStatus)}
              </Tag>
            )}
          </Box>
        </Box>
      )}
      <>
        <TextField
          readonly
          label={i18n.t('dashboard.todo.approvals.expenses.category')}
          value={collapseContentData.expense?.category?.name}
        />
      </>
      <>
        <TextField
          readonly
          label={i18n.t('dashboard.todo.approvals.expenses.vendor_name')}
          value={collapseContentData.expense?.merchantName || ''}
        />
      </>

      <Box flexDirection="row" gap="s24">
        <Box width="full">
          <MoneyField
            label={i18n.t('dashboard.todo.approvals.expenses.total_amount')}
            value={String(amount ? fromCents(Number(amount)) : null)}
            currency={String(collapseContentData?.currency)}
            readonly
          />
        </Box>
        <Box width="full">
          <TextField
            label={i18n.t('expenses.settings.signed_invoices.detail.form.fields.document_date')}
            value={dateBackendDateTimeToUI(collapseContentData?.effectiveOn)}
            readonly
          />
        </Box>
      </Box>

      {!isEmpty(files) && (
        <Documents
          documents={files.map(
            (file) =>
              new Document({ id: file.id, file: file.url, filename: file.filename, url: file.url })
          )}
        />
      )}

      <Link resourceId={collapseContentData.id} />
    </Box>
  )
}

export default ExpenseRightBlock
